// Utilities for AdminMatrimonyProfileEdit component.
import type { AuditLogEntry } from "src/types/adminMatrimonyProfileEdit.types";

export const AUDIT_PAGE_SIZE = 5;

export const fmtDate = (iso?: string | null): string => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const filterAndSortAuditLogs = (
  logs: AuditLogEntry[],
  actorFilter: string,
  search: string,
): AuditLogEntry[] => {
  let list = [...logs].sort((a, b) => {
    const ta = a.changedAt ? new Date(a.changedAt).getTime() : 0;
    const tb = b.changedAt ? new Date(b.changedAt).getTime() : 0;
    return tb - ta; // newest first
  });

  if (actorFilter !== "All Actors") {
    list = list.filter((l) => l.changedBy === actorFilter);
  }

  const q = search.trim().toLowerCase();
  if (q) {
    list = list.filter(
      (l) =>
        (l.fieldName || "").toLowerCase().includes(q) ||
        (l.oldValue || "").toLowerCase().includes(q) ||
        (l.newValue || "").toLowerCase().includes(q) ||
        (l.changedBy || "").toLowerCase().includes(q) ||
        (l.reason || "").toLowerCase().includes(q),
    );
  }

  return list;
};

export const getUniqueActors = (logs: AuditLogEntry[]): string[] => {
  const set = new Set<string>();
  for (const log of logs) {
    if (log.changedBy) set.add(log.changedBy);
  }
  return Array.from(set);
};
